export var DEFAULT_LOCALE = 'en';